import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useParams, useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { format } from 'date-fns';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import GridItem from '../../components/Grid/GridItem';
import styles from '../../assets/jss/pages/ListSeminarRegisteredManagermentStyle';
import CustomTable from '../../components/Table/Table';
import CustomTypography from '../../components/Typography/CustomTypography';
import {
    SEMINAR_STATUS_TEXT, PAID, statusApprove, statusType,
} from '../../common/Constants';
import {
    VideoCam,
    LoadMoreIcon,
} from '../../components/Icons/Icon';
import Button from '../../components/Button/CustomButton';
import Snackbar from '../../components/Snackbar/Snackbar';
import dateUtils, { convertDuration } from '../../utils/dateUtils';
import { navyColor } from '../../assets/jss/global';
import ViewHeader from '../../components/Header/ViewHeader';
import Pagination from '../../components/Pagination/Pagination';

const useStyles = makeStyles(styles);

export const Header = (props) => {
    const { eventInfo } = props;
    const intl = useIntl();
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={eventInfo?.settings_texts_sidebar_viewer?.field_name?.application_list || intl.formatMessage({ id: 'userRoutes.registeredSeminarListNewName' })}
                    isIntl={false}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};
const ListSeminarRegistered = (props) => {
    const {
        fetchListSeminarRegistered, listSeminarResult, clearData, listSeminarRegistered, locale,
        fetchListSeminarPaused, resetListSeminarPaused, listSeminarPaused, customText, customColorSeminar, eventInfo,
        /*  ★★ */
        customTimerctrl, getSettingCustomTimerctrl, clearCustomTimerctrl,
    } = props;
    const classes = useStyles();
    const intl = useIntl();
    const { shortName } = useParams();
    const history = useHistory();

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });

    useEffect(() => {
        fetchListSeminarPaused({ language: locale });
        return () => resetListSeminarPaused();
    }, []);

    useEffect(() => {
        setCurrentPage(listSeminarRegistered.page);
        setTotalPage(listSeminarRegistered.total_page);
    }, [listSeminarRegistered]);

    useEffect(() => {
        fetchListSeminarRegistered({ event_name: shortName, language: locale });
        return () => {
            clearData();
        };
    }, [shortName, locale]);

    /*  ★★ */
   // console.log( customTimerctrl )
   useEffect(() =>{
        getSettingCustomTimerctrl({eventShortName: shortName});
        return () =>{
            clearCustomTimerctrl();
        }
   },[shortName] );


    const createDataView = () => {
        const viewTotal = [];
        (Object.keys(listSeminarResult).forEach((key) => {
            createDateTitle(key);
            const viewTable = [];
            Object.keys(listSeminarResult[key]).forEach((roomData) => {
                const dataRow = [];
                const dataId = [];
                const dataDateTime = [];
                const seminarStatusArray = [];
                if (listSeminarResult[key][roomData]) {
                    listSeminarResult[key][roomData].forEach((seminar) => {
                        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
                        const yearStart = +seminar.date.split('-')[0];
                        const mouthStart = +seminar.date.split('-')[1];
                        const dayStart = +seminar.date.split('-')[2];
                        const hourStart = +seminar.stime.split(':')[0];
                        const minutesStart = +seminar.stime.split(':')[1];
                        const hourEnd = +seminar.etime.split(':')[0];
                        const minutesEnd = +seminar.etime.split(':')[1];
                        const timeRunningStart = new Date(yearStart, mouthStart, dayStart, hourStart, minutesStart);
                        const timeRunningEnd = new Date(yearStart, mouthStart, dayStart, hourEnd, minutesEnd);
                        
                        /*  ★★　TC_smn_afterを使用した期限切れ設定　*/
                        let active_Limit_end=30;
                        if(  customTimerctrl && customTimerctrl.hasOwnProperty("TC_smn_after") ){
                            active_Limit_end=customTimerctrl.TC_smn_after;
                        }
                        const seminarActive = utcDateNow >= timeRunningStart && utcDateNow < new Date(timeRunningEnd.setDate(timeRunningEnd.getDate() + active_Limit_end ))
                            && seminar.register_status === statusApprove.APPROVED;
                        const costPaid = seminar.cost > 0
                            ? `${intl.formatNumber(seminar.cost)}${intl.formatMessage({ id: 'common.yen' })}`
                            : `${intl.formatMessage({ id: 'common.free' })}`;
                        let statusPaid = '';
                        if (seminar.cost > 0) statusPaid = seminar.is_paid ? PAID[locale].PAIDED : PAID[locale].UNPAID;
                        dataRow.push([
                            `${seminar.stime}~${seminar.etime}`,
                            seminar.title,
                            seminar.speaker,
                            costPaid,
                            statusPaid,
                            SEMINAR_STATUS_TEXT[locale][seminar.seminar_status],
                            statusType[locale][seminar.register_status],
                            generateIconVideoWithDuration(seminarActive, seminar.media_duration),
                        ]);
                        dataId.push(seminar.id);
                        dataDateTime.push({ date: seminar.date, stime: seminar.stime, etime: seminar.etime });
                        seminarStatusArray.push(seminar.is_paused);
                    });
                }
                viewTable.push(createTable(roomData, dataRow, dataId, dataDateTime, roomData, seminarStatusArray));
            });
            const viewDate = (
                <React.Fragment key={key}>
                    {createDateTitle(key)}
                    {viewTable}
                </React.Fragment>
            );
            viewTotal.push(viewDate);
        }));
        return viewTotal.length > 0 ? viewTotal : (
            <GridItem
                xs={12}
                style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '20px',
                    zIndex: 1,
                    color: customColorSeminar?.contents_text_color,
                }}
            >
                <FormattedMessage id="noData" />
            </GridItem>
        );
    };

    const generateIconVideoWithDuration = (isActive, duration) => {
        let videoElement = <VideoCam color="gray" />;
        if (isActive) {
            videoElement = <VideoCam color="black" />;
        }

        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" flexWrap="wrap">
                {videoElement}
                <p>
                    {convertDuration(
                        duration,
                        intl.formatMessage({ id: 'common.hour' }),
                        intl.formatMessage({ id: 'common.minute' }),
                        intl.formatMessage({ id: 'common.second' }),
                    )}
                </p>
            </Box>
        );
    };

    const createDateTitle = (dateTitle) => (
        <Box style={{ margin: '20px 0 20px 0' }}>
            <CustomTypography bold variant="h5" customColor={customColorSeminar?.contents_text_color}>
                {intl.formatMessage({ id: 'common.date' })}
                {'  :  '}
                {dateUtils.formatJa(new Date(dateTitle), locale)}
            </CustomTypography>
        </Box>

    );

    const createTable = (title, dataRow, dataId, dataDateTime, key, seminarStatusArray) => (
        <React.Fragment key={key}>
            <CustomTypography
                variant="subtitle1"
                bold
                customColor={customColorSeminar?.contents_text_color}
            >
                <li>
                    {intl.formatMessage({ id: 'common.conferenceRoom' })}
                    {' '}
                    {title}
                </li>
            </CustomTypography>
            <CustomTable
                tableHead={[
                    customText?.field_name?.time || intl.formatMessage({ id: 'common.time1' }),
                    customText?.field_name?.lecture_name || intl.formatMessage({ id: 'seminar.lectureName' }),
                    customText?.field_name?.speaker || intl.formatMessage({ id: 'seminar.speaker' }),
                    customText?.field_name?.price || intl.formatMessage({ id: 'price' }),
                    customText?.field_name?.payment_status || intl.formatMessage({ id: 'seminar.paymentStatus' }),
                    customText?.field_name?.situation || intl.formatMessage({ id: 'status' }),
                    customText?.field_name?.approval_status || intl.formatMessage({ id: 'seminar.approvalStatus' }),
                    customText?.field_name?.attendance || intl.formatMessage({ id: 'seminar.attendance' }),
                ]}
                tableHeadWidth={['15%', '15%', '15%', '15%', '15%', '15%', '10%']}
                tableData={dataRow}
                onClick={(index) => handleOpenDetail(dataId[index], dataDateTime[index], seminarStatusArray[index])}
                cellColor={customColorSeminar?.list_table?.title_background_color || navyColor}
                cellTextColorHear={customColorSeminar?.list_table?.title_text_color}
                cellTextColorBody={customColorSeminar?.contents_text_color}
                cellBackgroundColor={customColorSeminar?.list_table}
            />
        </React.Fragment>
    );
    const handleOpenDetail = (idSeminar, dataDateTime, paused) => {
        const yearStart = +dataDateTime.date.split('-')[0];
        const mouthStart = +dataDateTime.date.split('-')[1];
        const dayStart = +dataDateTime.date.split('-')[2];
        const hourStart = +dataDateTime.stime.split(':')[0];
        const minutesStart = +dataDateTime.stime.split(':')[1];
        const hourEnd = +dataDateTime.etime.split(':')[0];
        const minutesEnd = +dataDateTime.etime.split(':')[1];
        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
        const timeRunningStartNew = new Date(yearStart, mouthStart - 1, dayStart, hourStart, minutesStart);
        const timeRunningEndNew = new Date(yearStart, mouthStart - 1, dayStart, hourEnd, minutesEnd);

        /*  ★★　TC_smn_afterを使用した期限切れ設定　*/
        let active_Limit_end=30;
        if(  customTimerctrl && customTimerctrl.hasOwnProperty("TC_smn_after") ){
            active_Limit_end=customTimerctrl.TC_smn_after;
        }
        /*  ★★　TC_smn_beforeを使用した利用可能開始設定　*/
        let active_Limit_start=30;
        if(  customTimerctrl && customTimerctrl.hasOwnProperty("TC_smn_before") ){
            active_Limit_start=customTimerctrl.TC_smn_before;
        }

        const dateBeforeSeminarViewNew = utcDateNow < new Date(timeRunningStartNew.setDate(timeRunningStartNew.getDate() - active_Limit_start));
        const seminarActiveAfterNew = utcDateNow >= new Date(timeRunningEndNew.setDate(timeRunningEndNew.getDate() + active_Limit_end));
        const beforeMessage = intl.formatMessage({ id: 'seminar.errorViewLimitBfr' }, {
            name: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list
            || intl.formatMessage({ id: 'home.seminar' }).toLocaleLowerCase(),
            DiffDay: active_Limit_start ,
            namePage: eventInfo?.settings_texts_sidebar_viewer?.field_name?.seminar_list
            || intl.formatMessage({ id: 'userRoutes.seminarList' }).toLocaleLowerCase(),
        });
        const afterMessage = intl.formatMessage({ id: 'seminar.errorOverLimitSmnDetail' },{pastDays:active_Limit_end});

        if (paused) {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'seminar.noViewSeminar' }, {
                    name: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list || intl.formatMessage({ id: 'home.seminar' }),
                }),
            });
        } else if (!dateBeforeSeminarViewNew && !seminarActiveAfterNew) {
            const { pathname } = history.location;
            const path = `${pathname}/${idSeminar}`;
            history.push(path);
        } else {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: dateBeforeSeminarViewNew ? afterMessage : beforeMessage,
            });
        }
    };
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const handleLoadMore = () => {
        fetchListSeminarRegistered({ event_name: shortName, page: currentPage + 1, language: locale });
    };

    const handleSearchWithPage = (changePage) => {
        fetchListSeminarRegistered({ event_name: shortName, page: changePage, language: locale });
    };

    const createTableLayout1 = (dataRow, dataId, dataDateTime, seminarStatusArray) => (
        <>
            <CustomTable
                tableHead={[
                    customText?.field_name?.time || intl.formatMessage({ id: 'common.time1' }),
                    customText?.field_name?.lecture_name || intl.formatMessage({ id: 'seminar.lectureName' }),
                    customText?.field_name?.speaker || intl.formatMessage({ id: 'seminar.speaker' }),
                    customText?.field_name?.price || intl.formatMessage({ id: 'price' }),
                    customText?.field_name?.payment_status || intl.formatMessage({ id: 'seminar.paymentStatus' }),
                    customText?.field_name?.situation || intl.formatMessage({ id: 'status' }),
                    customText?.field_name?.approval_status || intl.formatMessage({ id: 'seminar.approvalStatus' }),
                    customText?.field_name?.attendance || intl.formatMessage({ id: 'seminar.attendance' }),
                ]}
                tableHeadWidth={['15%', '15%', '15%', '15%', '15%', '15%', '10%']}
                tableData={dataRow}
                onClick={(index) => handleOpenDetail(dataId[index], dataDateTime[index], seminarStatusArray[index])}
                cellColor={customColorSeminar?.list_table?.title_background_color || '#edf4f7'}
                cellTextColorHear={customColorSeminar?.list_table?.title_text_color || '#4b4b4b'}
                borderColor="#4b4b4b"
                cellTextColorBody={customColorSeminar?.contents_text_color}
                cellBackgroundColor={customColorSeminar?.list_table}
                tableFooter={(
                    <Box display="flex" justifyContent="center">
                        <Pagination
                            page={listSeminarRegistered.page}
                            total={listSeminarRegistered.total_page}
                            onChange={(changePage) => handleSearchWithPage(changePage)}
                            colorBackgroundCustom={customColorSeminar?.list_table?.odd_record_background_color}
                            colorTextCustom={customColorSeminar?.button_background_color?.common_button}
                        />
                    </Box>
                )}
            />
        </>
    );

    const createDataViewLayout1 = () => {
        const dataRow = [];
        const dataId = [];
        const dataDateTime = [];
        const seminarStatusArray = [];
        for (let i = 0; i < listSeminarResult.length; i += 1) {
            const seminar = listSeminarResult[i];
            const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
            const timeRunningStart = new Date(`${seminar.date} , ${seminar.stime}`);
            const timeRunningEnd = new Date(`${seminar.date} , ${seminar.etime}`);
            const seminarActive = utcDateNow >= timeRunningStart && utcDateNow < new Date(timeRunningEnd.setDate(timeRunningEnd.getDate() + 30))
                && seminar.register_status === statusApprove.APPROVED;
            const costPaid = seminar.cost > 0
                ? `${intl.formatNumber(seminar.cost)}${intl.formatMessage({ id: 'common.yen' })}`
                : `${intl.formatMessage({ id: 'common.free' })}`;
            let statusPaid = '';
            if (seminar.cost > 0) statusPaid = seminar.is_paid ? PAID[locale].PAIDED : PAID[locale].UNPAID;
            const date = format(
                new Date(seminar.date),
                locale === 'en' ? 'MMMM dd (E)' : 'MM月dd日(E)',
                { locale: locale === 'en' ? enLocale : jaLocale },
            );
            const dateTime = (
                <>
                    <p>{seminar.room}</p>
                    <p>{date}</p>
                    <p>
                        {seminar.stime}
                        ~
                        {seminar.etime}
                    </p>
                </>
            );
            dataRow.push([
                dateTime,
                seminar.title,
                seminar.speaker,
                costPaid,
                statusPaid,
                SEMINAR_STATUS_TEXT[locale][seminar.seminar_status],
                statusType[locale][seminar.register_status],
                generateIconVideoWithDuration(seminarActive, seminar.media_duration),
            ]);
            dataId.push(seminar.id);
            dataDateTime.push({ date: seminar.date, stime: seminar.stime, etime: seminar.etime });
            seminarStatusArray.push(seminar.is_paused);
        }
        const viewTable = createTableLayout1(dataRow, dataId, dataDateTime, seminarStatusArray);
        return listSeminarResult.length > 0 ? viewTable : (
            <GridItem
                xs={12}
                style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '20px',
                    zIndex: 1,
                    color: customColorSeminar?.contents_text_color,
                }}
            >
                <FormattedMessage id="noData" />
            </GridItem>
        );
    };

    return (
        <div>
            {!_.isEmpty(eventInfo) && (
                <>
                    <GridItem>
                        {!_.isEmpty(listSeminarPaused) && (
                            <CustomTypography bold variant="subtitle1" customColor={customColorSeminar?.contents_text_color}>
                                {intl.formatMessage({ id: 'seminar.contact' })}
                            </CustomTypography>
                        )}

                        <Box display="flex" flexDirection="column" paddingLeft={1.5}>
                            {
                                !_.isEmpty(listSeminarPaused) && Object.keys(listSeminarPaused).map((key) => (
                                    listSeminarPaused[key].map((name) => (
                                        <CustomTypography color="danger">
                                            {intl.formatMessage({ id: 'seminar.cancelSeminar' }, {
                                                date: dateUtils.formatJaMonthDayOnly(new Date(key), locale),
                                                name,
                                            })}
                                        </CustomTypography>
                                    ))
                                ))
                            }
                        </Box>
                    </GridItem>
                    <GridItem>
                        {eventInfo.layout_seminar ? createDataViewLayout1() : createDataView()}
                    </GridItem>
                    { !eventInfo.layout_seminar && currentPage < totalPage && (
                        <GridItem align="center">
                            <Button
                                onClick={handleLoadMore}
                                color="navy"
                                gradient
                                size="md"
                                round
                                buttonTextColor={customColorSeminar?.button_text_color}
                                buttonBackgroundColor={customColorSeminar?.button_background_color?.common_button}
                            >
                                <LoadMoreIcon />
                                {intl.formatMessage({ id: 'common.seeMore' })}
                            </Button>
                        </GridItem>
                    )}
                    <Snackbar
                        open={snackbar.isOpen}
                        onClose={handleCloseSnackbar}
                        message={snackbar.message}
                        severity={snackbar.type}
                    />
                </>
            )}
        </div>
    );
};

ListSeminarRegistered.defaultProps = {
    listSeminarResult: {},
    listSeminarRegistered: {},
    listSeminarPaused: {},
    fetchListSeminarPaused: () => { },
    resetListSeminarPaused: () => { },
    customText: {},
    customColorSeminar: {},

    /* ★★ */
    getSettingCustomTimerctrl: () =>{},
    clearCustomTimerctrl : () => {},
    customTimerctrl: {},

    eventInfo: {},
    locale: 'ja',
};

ListSeminarRegistered.propTypes = {
    fetchListSeminarRegistered: PropTypes.func.isRequired,
    clearData: PropTypes.func.isRequired,
    listSeminarResult: PropTypes.oneOfType([() => null, PropTypes.object]),
    listSeminarRegistered: PropTypes.oneOfType([() => null, PropTypes.object]),
    listSeminarPaused: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchListSeminarPaused: PropTypes.func,
    resetListSeminarPaused: PropTypes.func,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColorSeminar: PropTypes.oneOfType([() => null, PropTypes.object]),

    /*  ★★　*/ 
    getSettingCustomTimerctrl: PropTypes.func,
    clearCustomTimerctrl: PropTypes.func,
    customTimerctrl: PropTypes.oneOfType([() => null, PropTypes.object]),

    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default ListSeminarRegistered;
